import { FC } from 'react';
import { UserRole } from '../../../services/models.types';
import WorkboardModelsTable from '../WorkboardModelsTable/WorkboardModelsTable';

const WorkboardCurrentModels: FC = () => (
  <WorkboardModelsTable 
    filterType="current"
    currentUserRole={UserRole.REVIEWER}
  />
);

export default WorkboardCurrentModels;
